export const FeatureFlags = {
  campus_flow: {
    flagKey: "ENG-4047_campus_flow",
    defaultValue: false,
  },
  floor_plan_section: {
    flagKey: "ENG-4921_floor_plan_section", // gitleaks:allow
    defaultValue: false,
  },
  floor_plan_pixel_processing: {
    flagKey: "ENG-4922_floor_plan_pixel_processing", // gitleaks:allow
    defaultValue: false,
  },
  map_view_by_school: {
    flagKey: "ENG-1398_map_view_by_school",
    defaultValue: false,
  },
  file_uploads: {
    flagKey: "ENG-4915_file_uploads",
    defaultValue: false,
  },
  upload_history: {
    flagKey: "ENG-2254_upload_history",
    defaultValue: false,
  },
  floor_plan_map_view: {
    flagKey: "ENG-4927_floor_plan_map_view",
    defaultValue: false,
  },
  hide_map_labels: {
    flagKey: "ENG-6475_hide_map_labels",
    defaultValue: false,
  },
  all_integrations: {
    flagKey: "ENG-6368_all_integrations",
    defaultValue: false,
  },
  zone_contrast_outlines: {
    flagKey: "ENG-4928_zone_contrast_outlines",
    defaultValue: false,
  },
  zone_data_rollback: {
    flagKey: "ENG-2255_zone_data_rollback",
    defaultValue: false,
  },
}
